<template>
  <MascotaComponent v-bind:component_usuario_uq="component_usuario_uq" />
</template>
  
  <script>
import MascotaComponent from "./MascotaComponent.vue";
export default {
  name: "DashboardExtendedTables",
  components: {
    MascotaComponent,
  },
  data: () => ({
    component_usuario_uq: "",
  }),
  created() {
    this.component_usuario_uq = localStorage.getItem("unico");
  },
};
</script>
  